<div class="wrapper">

  <!-- Preloader -->
  <div class="preloader flex-column justify-content-center align-items-center">
    <img class="animation__wobble" src="assets/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
  </div>



  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href="index3.html" class="brand-link">
      <img src="assets/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
        style="opacity: .8">
      <span class="brand-text font-weight-light">Prid Ecommerece</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <img src="assets/img/user2-160x160.jpg" class="img-circle elevation-2" alt="User Image">
        </div>
        <div class="info">
          <a href="#" class="d-block">Alexander Pierce</a>
        </div>
      </div>

      <!-- SidebarSearch Form -->
      <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item menu-open">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <a routerLink="/dashboard">
                Dashboard
              </a>
            </a>
          </li>

          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/countries" class="nav-link">
              <i class="nav-icon fas fa-calendar-alt"></i>
              <p>
                Countries
              </p>
            </a>
          </li>
          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/products" class="nav-link">
              <i class="nav-icon far fa-image"></i>
              <p>
                Products
              </p>
            </a>
          </li>
          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/orderhistory" class="nav-link">
              <i class="nav-icon far fa-image"></i>
              <p>
                Order History
              </p>
            </a>
          </li>
          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/categories" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Categories
              </p>
            </a>
          </li>

          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/locations" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Locations
              </p>
            </a>
          </li>


          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/discount-templates" class="nav-link active">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Discount Templates
              </p>
            </a>
          </li>

          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/users" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Users
              </p>
            </a>
          </li>

          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/retailers" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Retailers
              </p>
            </a>
          </li>

          <li *ngIf="Role==1" class="nav-item">
            <a routerLink="/distributors" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Distributors
              </p>
            </a>
          </li>
          <li class="nav-item" *ngIf="Role==4">
            <a routerLink="/retailer-home" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Retailer-Home
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/balance-history" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Balance Histories
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/invoices" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Invoice
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/login" class="nav-link">
              <i class="nav-icon fas fa-arrow-right"></i>
              <p>
                Logout
              </p>
            </a>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>



  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->

  <!-- Main Footer -->
  <footer class="main-footer">
    <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.2.0
    </div>
  </footer>
</div>

<!-- Navbar -->

<nav class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="index3.html" class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="#" class="nav-link">General Discount Templates</a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Navbar Search -->
      <li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" href="#" role="button">
          <i class="fas fa-search"></i>
        </a>
        <div class="navbar-search-block">
          <form class="form-inline">
            <div class="input-group input-group-sm">
              <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
              <div class="input-group-append">
                <button class="btn btn-navbar" type="submit">
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>

      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-comments"></i>
          <span class="badge badge-danger navbar-badge">3</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
              <img src="assets/img/user1-128x128.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  Brad Diesel
                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">Call me whenever you can...</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
              <img src="assets/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  John Pierce
                  <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">I got your message bro</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
              <img src="assets/img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  Nora Silvester
                  <span class="float-right text-sm text-warning"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">The subject goes here</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
        </div>
      </li>
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-warning navbar-badge">15</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 4 new messages
            <span class="float-right text-muted text-sm">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-users mr-2"></i> 8 friend requests
            <span class="float-right text-muted text-sm">12 hours</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 new reports
            <span class="float-right text-muted text-sm">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button">
          <i class="fas fa-th-large"></i>
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->

<div class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>General Discount Templates</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active">General Discount Templates</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid"  style="padding: 15px;">
    
    <div class="row ">
   

<div class="container-fluid">
    <div class="row mt-5">
        <div class="col-2"></div>
        <div class="col-2">
            <b>Domestic TopUp</b>
        </div>
        <div class="col-4">
           <input type="text" class="form-control" #DomesticTopUp>
        </div>
       
    </div>
    <div class="row mt-5">
        <div class="col-2"></div>
        <div class="col-2">
           <b>International TopUp</b>
         </div>
         <div class="col-4">
            <input type="text" class="form-control" #InternationalTopUp>
         </div>
         <div class="col-2"></div>
    </div>

    <div class="row mt-5">
        <div class="col-2"></div>
        <div class="col-2">
            <b>PridExpress</b>
         </div>
         <div class="col-4">
            <input type="text" class="form-control" #PridExpress>
         </div>
         <div class="col-2"></div>
    </div>
    <div class="row mt-5">
        <div class="col-2"></div>
        <div class="col-2">
            <b>Health</b>
         </div>
         <div class="col-4">
            <input type="text" class="form-control" #Health>
         </div>
         <div class="col-2"></div>
    </div>

    <div class="row mt-5">
        <div class="col-2"></div>
        <div class="col-8" style="text-align: center;">
          <button (click)="Submit(DomesticTopUp.value,InternationalTopUp.value,PridExpress.value,Health.value)" class="btn btn-primary">Submit</button> &nbsp;&nbsp;
        <button (click)="Cancel()" class="btn btn-info">Cancel</button>
        </div>

        <div class="col-2"></div>
    </div>
</div>

</div>
</div>


</div>